import { render } from "./size-guide-btn.vue?vue&type=template&id=3a07afe8"
import script from "./size-guide-btn.vue?vue&type=script&lang=js"
export * from "./size-guide-btn.vue?vue&type=script&lang=js"

import "./size-guide-btn.vue?vue&type=style&index=0&id=3a07afe8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__